// Module
var code = "<div class=\"ecom-domain-list\" tabindex=\"0\"> <div class=\"ecom-domain-list__item ecom-domain-list__item--current\"></div> <ul class=\"ecom-domain-list__items\" role=\"list\"> </ul> </div>";
// Exports
module.exports = code;